export const AuditLogRow = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z A',
  background: 'inkMid',
  borderBottom: '1px solid inkBorder',
  flexWrap: 'wrap',
  Timestamp: { text: (el, s) => s.timestamp || '--', fontSize: 'Y', color: 'inkSubtle', minWidth: 'E', fontFamily: 'monospace' },
  UserInfo: {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Y',
    minWidth: 'E',
    UserName: { text: (el, s) => s.userName || 'User', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    Badge: { extends: 'RbacBadge' }
  },
  ActionType: {
    text: (el, s) => s.actionType || 'READ',
    fontSize: 'Z',
    fontWeight: '600',
    minWidth: 'C',
    color: (el, s) => {
      const a = s.actionType || 'READ'
      if (a === 'READ') return 'inkSubtle'
      if (a === 'WRITE') return 'teal'
      if (a === 'EXPORT') return 'blue'
      if (a === 'DELETE') return 'red'
      return 'inkMuted'
    }
  },
  ResourceTarget: { text: (el, s) => s.resourceTarget || '--', fontSize: 'Z', color: 'inkMuted', flex: '1' },
  IpAddress: { text: (el, s) => s.ipAddress || '--', fontSize: 'Y', color: 'inkSubtle', fontFamily: 'monospace', flexShrink: '0' }
}
